import { EChartOption } from "echarts";
import { SkillsDeltaData } from "PFCore/hooks/queries/insights/use_skills_delta_query";

export const skillsDeltaChartConfig = (
  selectedSkills: string[],
  graphData: SkillsDeltaData | undefined,
  selectedN: number,
  t: (string) => string
): EChartOption => ({
  legend: {
    data: [t("newUser"), t("newSkill"), t("inactive")],
    left: "10%"
  },
  tooltip: {},
  xAxis: {
    data: selectedSkills.slice(0, selectedN),
    name: "Skills",
    axisLabel: {
      interval: 0,
      rotate: -15
    },
    axisLine: { onZero: false },
    splitLine: { show: false },
    splitArea: { show: false }
  },
  yAxis: {},
  grid: {
    bottom: 100
  },
  series: [
    {
      name: t("newUser"),
      type: "bar",
      stack: "one",
      data: selectedSkills
        .map(
          (skill) =>
            graphData?.new
              .find((item) => item?.skills === skill)
              ?.counts?.find((item) => item.type === "new user")?.profile_id || 0
        )
        .slice(0, selectedN)
    },
    {
      name: t("newSkill"),
      type: "bar",
      stack: "one",
      data: selectedSkills
        .map(
          (skill) =>
            graphData?.new
              .find((item) => item.skills === skill)
              ?.counts?.find((item) => item.type === "new skill")?.profile_id || 0
        )
        .slice(0, selectedN)
    },
    {
      name: t("inactive"),
      type: "bar",
      stack: "one",
      data: selectedSkills
        .map((skill) => (graphData?.inactive.find((item) => item.skills === skill)?.profile_id || 0) * -1)
        .slice(0, selectedN)
    }
  ]
});
